import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PaymentElement } from "@stripe/react-stripe-js";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import TermsAndConditionModal from "../modal/TermsAndConditionModal";
import { classNames } from "../../helpers";
type PaymentMethodProps = {
  redirectTo: string;
};
export default function PaymentMethod(props: PaymentMethodProps) {
  const { redirectTo } = props;
  const { t } = useTranslation("", {
    keyPrefix: "page.candidate.dashboard.payment",
  });
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState<string | undefined>(undefined);
  const [isProcessing, setIsProcessing] = useState(false);
  const [openTermsModal, setOpenTermsModal] = useState<boolean>(false);
  const [confirmTerms, setConfirmTerms] = useState<boolean>(false);

  const handleSubmit = async (e?: any) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsProcessing(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // redirect to  payment completion page
        return_url: redirectTo,
      },
    });

    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message);
    } else {
      setMessage("An unexpected error occurred.");
    }

    setIsProcessing(false);
  };
  const termsAndConditionAgreement = (agree: boolean) => {
    setConfirmTerms(agree);
    setOpenTermsModal(false);
  };

  return (
    <div className="w-full h-full">
      <h3 className="text-gray-700 text-sm font-medium mb-3">
        {t("paymentMethod")}
      </h3>
      <form
        id="payment-form"
        onSubmit={handleSubmit}
        className="flex flex-col gap-6"
      >
        <PaymentElement id="payment-element" />
        {/* Show any error or success messages */}
        {message && (
          <div className="text-red-500 text-sm" id="payment-message">
            {message}
          </div>
        )}
        <div className="flex items-center  gap-4">
          <input
            required
            id="checked-checkbox"
            aria-describedby="checkbox-agreement"
            name="checkbox-agreement"
            type="checkbox"
            onChange={(e) => setConfirmTerms(e.target.checked)}
            checked={confirmTerms}
            className="focus:ring-brandblue-500 h-4 w-4 text-brandblue-600 border-gray-300 rounded"
          />
          <label
            htmlFor="checked-checkbox"
            className="text-sm  font-normal text-gray-500 "
            onClick={() => {
              setOpenTermsModal(true);
            }}
            dangerouslySetInnerHTML={{
              __html: t("privacyAgreement", {
                label: `<span  
                        class="text-blue-600 cursor-pointer underline-offset-4 underline">${t(
                          "policies"
                        )}</span>`,
              }),
            }}
          ></label>
        </div>

        <div className="flex justify-start items-center gap-4">
          <button
            className="inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brandblue-500 focus:ring-offset-2   sm:w-auto"
            id="submit"
            type="reset"
            disabled={isProcessing || !stripe || !elements}
          >
            <span id="button-text">{t("cancel")}</span>
          </button>
          <button
            className={classNames(
              "w-full sm:w-auto flex justify-center py-2 px-4 bg-brandblue-600 hover:bg-brandblue-700 focus:ring-brandblue-500 border border-transparent rounded-md shadow-sm text-sm font-medium text-white  focus:outline-none focus:ring-2 focus:ring-offset-2",
              !confirmTerms ? "cursor-not-allowed" : ""
            )}
            disabled={isProcessing || !stripe || !elements || !confirmTerms}
            type="submit"
          >
            <span id="button-text">
              {isProcessing ? t("process") : t("payNow")}
            </span>
          </button>
        </div>
      </form>
      <TermsAndConditionModal
        isOpen={openTermsModal}
        onClose={termsAndConditionAgreement}
      />
    </div>
  );
}
